import type { FeatureDefinition } from './features';

export default [
  {
    name: 'viewBettermileReports',
    action: 'r:bettermile-reports',
    isMainView: true,
    isRootLevel: true,
    route: 'keyStatistics'
  },
  {
    action: 'r:route-reports',
    isMainView: true,
    isRootLevel: true,
    name: 'viewRouteReports',
    route: 'tenantDashboards',
    routeParams: {
      dashboardName: 'betterRouteReports'
    }
  },
  {
    action: 'r:rtt-reports',
    isMainView: true,
    isRootLevel: true,
    name: 'viewRttReports',
    route: 'tenantDashboards',
    routeParams: {
      dashboardName: 'betterTrackingReports'
    }
  },
  {
    action: 'r:cloud-tracking-reports',
    isMainView: true,
    isRootLevel: true,
    name: 'cloudTrackingReports',
    route: 'tenantDashboards',
    routeParams: {
      dashboardName: 'cloudTrackingReports'
    }
  },
  {
    action: 'r:parcel-finder',
    isMainView: true,
    isRootLevel: true,
    name: 'parcelFinder',
    route: 'parcelList'
  },
  {
    action: 'r:places-dgw-reports',
    isMainView: true,
    isRootLevel: true,
    name: 'viewPlacesDGWReports',
    route: 'tenantDashboards',
    routeParams: {
      dashboardName: 'betterRouteGeocodingReports'
    }
  },
  {
    action: 'r:places-deep-int-reports',
    isMainView: true,
    isRootLevel: true,
    name: 'viewPlacesDeepIntReports',
    route: 'tenantDashboards',
    routeParams: {
      dashboardName: 'apiGeocodingReports'
    }
  },
  {
    name: 'viewDepotManagementList',
    action: 'r:depot-mgmt-list',
    isMainView: true,
    isRootLevel: true,
    route: 'configTenantDepots'
  },
  {
    name: 'canCreateDepot',
    action: 'c:depot',
    needs: 'r:depot-mgmt-list'
  },
  {
    name: 'viewApiAccessManagement',
    action: 'r:api-access-management',
    isMainView: true,
    isRootLevel: true,
    route: 'apiAccessManagement'
  },
  {
    name: 'writeApiAccessManagement',
    action: 'w:api-access-management',
    needs: 'r:api-access-management'
  },
  {
    name: 'readHealthStatus',
    action: 'r:health-status',
    isMainView: true,
    isRootLevel: true,
    route: 'healthStatus'
  },
  {
    name: 'canUpdateDepot',
    action: 'u:depot',
    needs: 'r:depot-mgmt-list'
  },
  {
    name: 'viewAccountCounting',
    action: 'r:app-user-licences',
    isMainView: true,
    isRootLevel: true,
    route: 'licenses'
  },
  {
    name: 'viewDGWPages',
    action: 'r:dgw-pages',
    isMainView: true,
    isRootLevel: true,
    route: 'dataGatewayAssignmentListContainer'
  },
  {
    name: 'canViewRoleCreation',
    action: 'r:role',
    isMainView: true,
    isRootLevel: true,
    route: 'roleCreation'
  },
  {
    name: 'canCreateRole',
    action: 'c:role',
    auto: ['r:role']
  },
  {
    name: 'canDeleteRole',
    action: 'd:role',
    auto: ['r:role']
  },
  {
    name: 'canUpdateRole',
    action: 'u:role',
    auto: ['r:role']
  },
  {
    name: 'readBOUsers',
    action: 'r:bo-user',
    isMainView: true,
    isRootLevel: true,
    route: 'backofficeUsersTenant'
  },
  {
    name: 'createBOUser',
    action: 'c:bo-user',
    auto: ['r:bo-user']
  },
  {
    name: 'updateBOUsers',
    action: 'u:bo-user',
    auto: ['r:bo-user']
  },
  {
    name: 'deleteUser',
    action: 'd:bo-user',
    auto: ['r:bo-user']
  },
  {
    name: 'viewDrivers',
    action: 'r:driver',
    isMainView: true,
    isRootLevel: true,
    route: 'appAccounts'
  },
  {
    name: 'deleteDriver',
    action: 'd:driver',
    auto: ['r:driver']
  },
  {
    name: 'createDriver',
    action: 'c:driver',
    auto: ['r:driver']
  },
  {
    name: 'updateDriver',
    action: 'u:driver',
    auto: ['r:driver']
  },
  {
    name: 'viewTempDrivers',
    action: 'r:temp-driver',
    isMainView: true,
    isRootLevel: true,
    route: 'appAccounts'
  },
  {
    name: 'deleteTempDriver',
    action: 'd:temp-driver',
    auto: ['r:temp-driver']
  },
  {
    name: 'createTempDriver',
    action: 'c:temp-driver',
    auto: ['r:temp-driver']
  },
  {
    name: 'updateTempDriver',
    action: 'u:temp-driver',
    auto: ['r:temp-driver']
  },
  {
    name: 'activateDriver',
    action: 'activate-user',
    auto: ['r:temp-driver']
  },
  {
    name: 'deactivateDriver',
    action: 'deactivate-user',
    auto: ['r:temp-driver']
  },
  {
    name: 'viewAddressLocationValidation',
    action: 'r:address-location-correction',
    isMainView: true,
    isRootLevel: true,
    route: 'tenantAddressLocationValidation'
  },
  {
    name: 'canAssignPermission',
    action: 'can-assign-permission',
    auto: ['r:temp-driver', 'r:driver', 'r:bo-user']
  },
  {
    name: 'viewSmartInsights',
    action: 'r:smart-insights',
    needs: 'r:bettermile-reports'
  }
] as const satisfies readonly FeatureDefinition[];
